module.exports = ".all-wrapper.menu-side\n{\n    background-color: transparent !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/forgot-password/forgot-password.component.css
// module id = ./src/app/forgot-password/forgot-password.component.css
// module chunks = main